import React, { FC, ReactNode, useContext, useReducer } from "react";
import { ResultRegion, SpecialtyGroupExceptionStatus } from "@app/projects/results/common";
import { QESButton } from "@app/shared/qes-standards";
import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";

import SpecialtyGroupException from "@app/projects/results/common/specialtyGroupException";
import SpecialtyGroupExceptionPanel, {
  getInitialFormState,
  mergeFormAndException
} from "@app/projects/network-assessment/SpecialtyGroupExceptionPanel";
import { editExceptionFormReducer, hasChanges, hasValidFields } from "@app/exceptions/editExceptionReducer";

type ExceptionFlyoutProps = {
  exception: SpecialtyGroupException;
  specialtyGroupName: string;
  specialtyGroupCode: string;
  region: ResultRegion;
  handleSubmit: (exceptionToSubmit: SpecialtyGroupException) => void;
} & { children?: ReactNode };

const ExceptionFlyout: FC<React.PropsWithChildren<ExceptionFlyoutProps>> = (props: ExceptionFlyoutProps) => {
  const flyoutContext = useContext(FlyoutContext);
  const [exceptionFormState, formDispatch] = useReducer(editExceptionFormReducer, getInitialFormState(props.exception));

  const handleSubmit = () => {
    const result = mergeFormAndException(props.exception, exceptionFormState, props.region, props.specialtyGroupCode);
    props.handleSubmit(result);
    flyoutContext.handleCloseFlyout();
  }

  return (
    <>
      <SpecialtyGroupExceptionPanel
        exception={props.exception}
        specialtyGroupName={props.specialtyGroupName}
        specialtyGroupCode={props.specialtyGroupCode}
        region={props.region}
        formState={exceptionFormState}
        formDispatch={formDispatch}/>
      <FlyoutFooter
        submitButton={<QESButton qesType="primary" qesTestId="exception-flyout__submit"
                                 disabled={!!props.exception && props.exception.specialtyGroupExceptionStatus !== SpecialtyGroupExceptionStatus.Archived
                                   && !hasChanges(exceptionFormState) || !hasValidFields(exceptionFormState)}
                                 onClick={handleSubmit}>Submit</QESButton>}
      />
    </>
  );
}

export default ExceptionFlyout;